export const USER_AVATAR_DEFAULT =
  '//gw.alicdn.com/tfs/TB1DYHLwMHqK1RjSZFEXXcGMXXa-56-62.svg';
export const BOT_AVATAR_DEFAULT =
  '//test-bucket-diyva-webui-chat.s3.amazonaws.com/chatbotui_avatar/default_ama_avatar.jpg';
export const SERVICE_URL = 'https://model.api.dev.diyva.org';
export const SERVICE_URL_V2 = 'https://agent.api.dev.diyva.org';
export const EMPTY_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
export const DEFAULT_MESSAGE = {
  micPermissionErr: 'Please allow to use your microphone for voice input.',
  audioSupportErr: 'The Audio Recorder is not supported in your browser.',
  noResponseErr: 'Could not get response. Please try again.',
  sessionExpired: 'Session expired. Please reload the chat.',
  chatEnd:
    'Your chat session has ended due to inactivity.\nPlease start a new conversation if you have further questions.',
  start: 'Please click Start button to begin',
  startWithContact:
    'Please enter your contact details in case we need to follow up',
  inputPlaceholder: 'Type here or click the mic to speak',
  recorderErr: 'Recorder not working.',
  complete:
    'Your chat session has completed.\nPlease start a new conversation if you have further questions.',
  sessionCompletedTitle: 'Session Completed',
  sessionClosedTitle: 'Session Closed',
};
export const START_MSG_ID = '_start_msg_';
export const END_MSG_ID = '_end_msg_';
